"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _makeQueryKey = _interopRequireDefault(require("../../../utils/make-query-key"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getWebShellProductQueryKey = function getWebShellProductQueryKey() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    productCode = _ref.productCode,
    marketplace = _ref.marketplace,
    language = _ref.language;
  return (0, _makeQueryKey["default"])(['webShellClient', 'product', {
    productCode: productCode,
    marketplace: marketplace,
    language: language
  }]);
};
var _default = exports["default"] = getWebShellProductQueryKey;